import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Note from '@shared/ui/messages/Note';
import MasterBalance from './MasterBalance';
import { useTranslation } from 'react-i18next';
import { TelegramBtn } from '@widgets/buttons';

export default function TopUpBalanceDialog() {
  const { t } = useTranslation();

  return (
    <>
      <DialogContent>
        <MasterBalance />
        <div className="form">
          <Note
            type="info"
            title={t('information')}
            content={t('manual_balance_top_up')}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <TelegramBtn />
      </DialogActions>
    </>
  );
}
